import React from "react";
import Button from "../components/Button";
import Header from "../components/Header";

export default function Error() {
  return (
    <div class="error-page">
      <div class="button-container error-button">
        <Button text="Back Home" link="/" />
      </div>

      <div class="error-container">
        <div class="error-header">
          <Header text="WHOOPS! 404" />
        </div>
      </div>

      <div class="error-footer">
        <span>Seems you are lost</span>
      </div>
    </div>
  );
}
